export const styles = (theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },

  tableHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid"
  },
  columnHeader: {
    backgroundColor: "#F7F7F7",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid"
  },
  fieldName: {
    border: "1px solid #e0e0e0",
    borderTop: 0
  },
  fieldValue: {
    border: "1px solid #e0e0e0",
    borderTop: 0,
    borderLeft: 0
  },
  fieldValueChanged: {
    color: "red",
    border: "1px solid #e0e0e0",
    borderTop: 0,
    borderLeft: 0
  },

});
